import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import type { AxiosResponse } from 'axios';
import { axiosInstance } from '@shared/lib/axios';
import type { TAxiosError } from '@shared/lib';
import { MUTATIONS_INFO } from '@shared/lib';
export type TUseSetPermanentRequestPayload = {
  newPassword: string;
};
export type TUseSetPermanentPasswordParams = {
  options?: UseMutationOptions<AxiosResponse, unknown, TUseSetPermanentRequestPayload>;
};
export const useSetPermanentPassword = ({
  options
}: TUseSetPermanentPasswordParams = {}) => useMutation<AxiosResponse, TAxiosError, TUseSetPermanentRequestPayload>(params => axiosInstance.post<null, AxiosResponse, TUseSetPermanentRequestPayload>(MUTATIONS_INFO.setPassword, params), {
  ...options,
  onSuccess: async (data, variables, context) => {
    await axiosInstance.post(MUTATIONS_INFO.logout);
    options?.onSuccess?.(data, variables, context);
  }
});